import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';

export const IconShieldCheckGroup: React.FC<SvgProps> = (props) => {
  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M8.40437 14.5252C8.19019 14.6078 7.95294 14.6078 7.73876 14.5252C6.06756 13.8835 4.63031 12.7501 3.61686 11.2745C2.6034 9.79885 2.06142 8.05051 2.0625 6.26039V3.48697C2.0625 3.24179 2.1599 3.00664 2.33327 2.83327C2.50665 2.6599 2.74179 2.5625 2.98697 2.5625H13.1561C13.4014 2.5625 13.6365 2.6599 13.8098 2.83327C13.9832 3.00664 14.0806 3.24179 14.0806 3.48697V6.26039C14.0817 8.05051 13.5397 9.79885 12.5263 11.2745C11.5129 12.7501 10.0756 13.8835 8.40437 14.5252Z"
        fill="#0B7F0B"
        stroke="#0B7F0B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8712 5.77832L7.14261 9.97296L5.27832 8.57475"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const IconShieldCheckSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconShieldCheckGroup {...props} />
    </svg>
  );
};
